import { Post } from "./request";

export function IsBlacklisted(dispatch, emailAddress) {
  return Post(dispatch, "IsBlacklisted", "", { EmailAddress: emailAddress });
}

export function IsExcluded(dispatch, emailAddress) {
  return Post(dispatch, "IsExcluded", "", { EmailAddress: emailAddress });
}

export function RemoveFromMailExclusion(dispatch, emailAddress) {
  return Post(dispatch, "RemoveFromMailExclusion", "", {
    EmailAddress: emailAddress,
  });
}

export function Unsuppress(dispatch, emailAddress) {
  return Post(dispatch, "Unsuppress", "", { EmailAddress: emailAddress });
}
